





import {Component, Prop, PropSync, Vue, Watch} from 'vue-property-decorator';
import PxDropdown from "@/views/components/input/formFields/PxDropdown.vue";
import PxNumberInput from "@/views/components/input/formFields/PxNumberInput.vue";


@Component({
  components: {
    PxDropdown,
    PxNumberInput
  },
})
export default class TrafficDistributionControl extends Vue {
  @PropSync('trafficPct', {type: Number}) trafficPct!: number;



  sync() {
    this.$emit('update:trafficPct', this.trafficPct);
    // createD3Graph(this.value)
  }

}
